function normalizeWorkspace(workspace) {
  return {
    ...workspace,
    workspaceId: workspace.workspaceId ?? workspace.id,
  }
}

export async function fetchWorkspaceSummaryPage(requestJson, {
  limit = 50,
  cursor,
  q,
  status,
  source,
  includeArchived = false,
} = {}) {
  const params = new URLSearchParams({
    pagination: 'cursor',
    limit: String(limit),
  })

  if (cursor) {
    params.set('cursor', cursor)
  }
  if (q?.trim()) {
    params.set('q', q.trim())
  }
  if (status) {
    params.set('status', status)
  } else {
    params.set('includeArchived', includeArchived ? 'true' : 'false')
  }
  if (source) {
    params.set('source', source)
  }

  const data = await requestJson(`/workspaces/summary?${params}`)
  const rawItems = Array.isArray(data?.items)
    ? data.items
    : (Array.isArray(data?.workspaces) ? data.workspaces : [])

  return {
    items: rawItems.map(normalizeWorkspace),
    limit: typeof data?.limit === 'number' && data.limit > 0 ? data.limit : limit,
    hasMore: data?.hasMore === true,
    nextCursor: typeof data?.nextCursor === 'string' ? data.nextCursor : null,
  }
}

const EMPTY_COUNTS = Object.freeze({
  total: 0,
  visible: 0,
  byStatus: Object.freeze({ creating: 0, ready: 0, failed: 0, archived: 0, deleting: 0 }),
  bySource: Object.freeze({ github: 0, upload: 0 }),
})

function readNumberField(value) {
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : 0
}

function normalizeCountsByStatus(value) {
  const source = value && typeof value === 'object' ? value : {}
  return {
    creating: readNumberField(source.creating),
    ready: readNumberField(source.ready),
    failed: readNumberField(source.failed),
    archived: readNumberField(source.archived),
    deleting: readNumberField(source.deleting),
  }
}

function normalizeCountsBySource(value) {
  const source = value && typeof value === 'object' ? value : {}
  return {
    github: readNumberField(source.github),
    upload: readNumberField(source.upload),
  }
}

export function normalizeWorkspaceCounts(payload) {
  if (!payload || typeof payload !== 'object') {
    return { ...EMPTY_COUNTS, byStatus: { ...EMPTY_COUNTS.byStatus }, bySource: { ...EMPTY_COUNTS.bySource } }
  }
  return {
    total: readNumberField(payload.total),
    visible: readNumberField(payload.visible),
    byStatus: normalizeCountsByStatus(payload.byStatus),
    bySource: normalizeCountsBySource(payload.bySource),
  }
}

export async function fetchWorkspaceCounts(requestJson) {
  const data = await requestJson('/workspaces/counts')
  return normalizeWorkspaceCounts(data)
}
